import { SubscriptionsState } from '@pages/subscriptions/store/states/subscriptions.state';
import { BillableSubscriptionsState } from '@pages/subscriptions/store/states/billable-subscriptions.state';
import { AccountAutoRenewState } from '@pages/subscriptions/store/states/account-auto-renew.state';
import { AutoRenewNotificationsState } from '@pages/subscriptions/store/states/auto-renew-notifications.state';
import { SubscriptionDevicesState } from '@pages/subscriptions/store/states/subscription-devices.state';

export const subscriptionsState = [
  SubscriptionsState,
  BillableSubscriptionsState,
  AccountAutoRenewState,
  AutoRenewNotificationsState,
  SubscriptionDevicesState,
];
